<template lang="pug">
  div(v-if="hasError").help-block.help-error
    | {{ message }}
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import type {WebFormModelInterface} from 'capitalist-shared/src/core/model';

@Component({})
export default class ErrorModelHint extends Vue {
  @Prop({required: true})
  model!: WebFormModelInterface;

  @Prop({required: true})
  attribute!: string;

  get hasError(): boolean {
    return this.model.errors.hasErrorsSplit(this.attribute);
  }

  get message(): string {
    return this.model.errors.getErrorSplit(this.attribute) + '';
  }
}
</script>

<style lang="less" scoped>
.help-error {
  color: #910202;
}
</style>
